import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import CircularProgress from '@mui/material/CircularProgress';
import { IconWrapper, Paragraph, Title } from '../../../pages/auth/styled';

type Props = {
    open: boolean;
    title: string;
    message: string;
};

const ModalLoading = ({ open, title, message }: Props) => {
    useEffect(() => {
        window.addEventListener('beforeunload', alertUser);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
        };
    }, []);

    const alertUser = (e: any) => {
        e.preventDefault();
        e.returnValue = '';
    };

    return (
        <Modal
            open={open}
            onClose={() => ''}
            showCloseIcon={false}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            <Box sx={{ mt: 1 }}>
                <Title variant="h4">{title}</Title>
                <IconWrapper>
                    <CircularProgress size={70} thickness={2} />
                </IconWrapper>
                <Paragraph>¡Espere por favor!</Paragraph>
                <Typography
                    align="center"
                    variant="subtitle2"
                    color="textSecondary"
                >
                    {message}
                </Typography>
            </Box>
        </Modal>
    );
};

export default ModalLoading;
